module.exports = __webpack_public_path__ + "static/img/shezhi_qianbao.33896580.png";